module.exports = __webpack_public_path__ + "static/media/innanverdlaeri.d0292a9f.png";